import React, { useContext, useMemo, useState } from "react";
import userIcon from "assets/img/userIcon.png";
import PopoverMenu from "./PopoverMenu";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import Tooltip from "./Tooltip";

const HeaderAccount = ({ loggedInRole, groupID }) => {
  const navigate = useNavigate();

  const { userData, logout } = useContext(AuthContext);
  const [open, setOpen] = useState(false);

  const options = useMemo(() => {
    return [
      {
        value: "_My_Profile",
        label: t("_My_Profile"),
        onClick: () => {
          navigate("/app/header/change-profile");
        },
      },

      ...(loggedInRole !== "PA"
        ? [
            {
              value: "_Billing",
              label: t("_Billing"),
              onClick: () => {
                navigate(`/app/header/billing`);
              },
            },
          ]
        : []),

      ...(loggedInRole == "EA" || loggedInRole == "EU"
        ? []
        : [
            {
              value: "_Settings",
              label: t("_Settings"),
              onClick: () => {
                navigate(`/app/header/settings/${groupID}`);
              },
            },
          ]),

      {
        value: "_Log_out",
        label: t("_Log_out"),
        onClick: () => {
          logout();
        },
      },
    ];
  }, [loggedInRole, groupID]);

  const name = userData.name;

  return (
    <PopoverMenu
      options={options}
      offsetX={22}
      contentMinWidth={"150px"}
      className="px-6 py-3"
      open={open}
      setOpen={setOpen}
    >
      <div className="flex cursor-pointer relative">
        <img
          src={userData?.profileImg || userIcon}
          className="rounded-full h-9  w-10 object-cover ltr:mr-[8px] rtl:ml-[8px] select-none"
          alt="user-icon"
        />
        <h1 className="font-nunito my-auto ltr:mr-[31px] rtl:ml-[31px] hidden sm:inline-block font-bold">
          {name?.length > 12 ? (
            <Tooltip content={name} disabled={open}>
              <span>{name.substring(0, 12) + "..."}</span>
            </Tooltip>
          ) : (
            name
          )}
        </h1>
      </div>
    </PopoverMenu>
  );
};

export default HeaderAccount;
